import { isMatching, P } from "ts-pattern";

import type { TCorrection, TPatient } from "../reducers/dashboard";

export function getLastCorrection(patient: TPatient): TCorrection | undefined {
  return patient.course.correction[patient.course.correction.length - 1];
}

const patientPattern = {
  patient_id: P.number,
};

/**
  Use this function to determine if value is a patient object.
 */
export function isPatient(value: unknown): value is TPatient {
  // Previous check was `value && Object.keys(value).length > 0 && value.patient_id`
  return isMatching(patientPattern, value);
}
